export default {
  authToken: (state) => state.authToken,
  lastActionAt: (state) => state.lastActionAt,
  lastTokenRefreshAt: (state) => state.lastTokenRefreshAt,
  tokenExpireInMinutes: (state) => state.tokenExpireInMinutes,
  userData: (state) => state.userData,

  userName: (state) => {
    return state.userData
      ? `${ state.userData.forename } ${ state.userData.lastname }`
      : ''
  },

  userGroup: (state) => {
    return state.userData
      ? state.userData.user_group
      : ''
  },

  userTenantId: (state) => state.userTenantId,

  isSSO: (state) => {
    return state.userData
      ? state.userData.is_sso
      : false
  },
}
